import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";

const CourierInvoiceAccountStatusFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false
}) => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            {showLabel && <h5>{"Entegratör Durumu"}</h5>}
            <SelectField
                showSearch
                value={value}
                data-testid="courier_invoice_account_status"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="available_rate_option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                <SelectField.Option
                    data-testid="courier_invoice_account_status_option"
                    value={"Yeni Başvuru"}
                >
                    Yeni Başvuru
                </SelectField.Option>
                <SelectField.Option
                    data-testid="courier_invoice_account_status_option"
                    value={"Kurulum Yapıldı"}
                >
                    Kurulum Yapıldı
                </SelectField.Option>
                <SelectField.Option
                    data-testid="courier_invoice_account_status_option"
                    value={"Başarısız"}
                >
                    Başarısız
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default CourierInvoiceAccountStatusFilter;
